// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer-module__SideDrawer__2bJWo","Open":"SideDrawer-module__Open__3K3Oa","Close":"SideDrawer-module__Close__2rdTq","Logo":"SideDrawer-module__Logo__1Mx5y"};